import OnboardingApi from "../../Family/Onboarding/OnboardingApi";
import { failureMessage } from "../../Family/Onboarding/OnboardingRules";

/**
 * « Ce n'est pas votre compte? » under the password of the family login popup. One click asks the
 * server to mail the address; the line then says the email went out, in the same words whatever
 * the account is, as the server answers the same. The link comes back for each email the
 * password panel opens on.
 */
export default class NotMyAccount {
  private readonly ask: JQuery<HTMLElement>;
  private readonly sent: JQuery<HTMLElement>;
  private readonly error: JQuery<HTMLElement>;
  private email = "";
  private busy = false;

  constructor(
    private readonly root: JQuery<HTMLElement>,
    private readonly api: OnboardingApi,
  ) {
    this.ask = root.find(".js-gate-not-mine-ask");
    this.sent = root.find(".js-gate-not-mine-sent");
    this.error = root.find(".js-gate-not-mine-error");
    this.root.on("click", ".js-gate-not-mine-ask", () => {
      void this.send();
    });
  }

  /** The password panel opened on this email: the link is offered for it. */
  public Show(email: string): void {
    this.email = email;
    this.ask.removeClass("hide").prop("disabled", false);
    this.sent.addClass("hide");
    this.error.addClass("hide");
  }

  private async send(): Promise<void> {
    if (this.busy || this.email === "") {
      return;
    }
    const email = this.email;
    this.busy = true;
    this.ask.prop("disabled", true);
    this.error.addClass("hide");
    try {
      await this.api.NotMyAccount(email);
      if (email !== this.email) {
        return;
      }
      this.writeSent(email);
      this.ask.addClass("hide");
      this.sent.removeClass("hide");
    } catch (failure) {
      this.error
        .text(failureMessage(failure) ?? this.error.attr("data-failed") ?? "")
        .removeClass("hide");
    } finally {
      this.busy = false;
      this.ask.prop("disabled", false);
    }
  }

  /** « Courriel envoyé à <email>. », the email in bold and as text, never as markup. */
  private writeSent(email: string): void {
    const [before, after] = (this.sent.attr("data-text") ?? "").split(
      "%email%",
    );
    this.sent.find(".js-gate-not-mine-sent-before").text(before ?? "");
    this.sent.find(".js-gate-not-mine-sent-email").text(email);
    this.sent.find(".js-gate-not-mine-sent-after").text(after ?? "");
  }
}
